import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=bbce4b24&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=bbce4b24&prod&scoped=true&lang=scss"
import style1 from "./Index.vue?vue&type=style&index=1&id=bbce4b24&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbce4b24",
  null
  
)

export default component.exports